import { token } from 'constant/localStorage'

const API_URL = process.env.REACT_APP_API_URL

export const listData = async (isInstitution = false) => {
  try {
    const params = new URLSearchParams({ limit: 0, page: 0, user_role_id: isInstitution ? 'USERROLE-INSTITUTION' : 'USERROLE-FUND_MANAGER' })
    const response = await fetch(`${API_URL}/externalusers/registrationdata?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token()}`
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}